import React from 'react';
import * as Yup from 'yup';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { rodnecislo } from 'rodnecislo';

export default Yup.object().shape({
  first_name: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),

  last_name: Yup.string().required(
    <FormattedMessage
      id="onboarding_personal_form_required"
      defaultMessage={dlt['onboarding_personal_form_required']}
    />
  ),

  birth_number: Yup.string()
    .required(
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />
    )
    .test(
      null,
      <FormattedMessage
        id="onboarding_personal_form_bad_value"
        defaultMessage={dlt['onboarding_personal_form_bad_value']}
      />,
      (inputValue) => {
        let rc = rodnecislo(inputValue);
        return rc.isValid();
      }
    ),

  phone: Yup.string()
    .matches(
      /^((\+)(\d{3})([ ]?))((\d{3})([ ]?)){2}(\d{3})$/,
      <FormattedMessage
        id="onboarding_personal_form_bad_value_phone"
        defaultMessage={dlt['onboarding_personal_form_bad_value_phone']}
      />
    )
    .required(
      <FormattedMessage
        id="onboarding_personal_form_required"
        defaultMessage={dlt['onboarding_personal_form_required']}
      />
    ),

  email: Yup.string()
    .email(
      <FormattedMessage
        id="onboarding_personal_form_bad_value"
        defaultMessage={dlt['onboarding_personal_form_bad_value']}
      />
    )
    .nullable(),

  email_confirmation: Yup.string().when('email', {
    is: (val) => val && val.length > 0,
    then: Yup.string()
      .oneOf(
        [Yup.ref('email')],
        <FormattedMessage
          id="onboarding_personal_form_email_match"
          defaultMessage={dlt['onboarding_personal_form_email_match']}
        />
      )
      .required(
        <FormattedMessage
          id="onboarding_personal_form_email_confirm_required"
          defaultMessage={dlt['onboarding_personal_form_email_confirm_required']}
        />
      ),
  }),
});
